module.exports = __webpack_public_path__ + "static/img/10.f58098b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-cn/10.jpg
// module id = xqO8
// module chunks = 1